import React from 'react';
import PropTypes from 'prop-types';
import './Button.css';

const Button = ({
  type = 'button',
  onClick,
  disabled = false,
  className = '',
  children,
  ariaLabel,
  title,
}) => {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`btn ${className}`}
      aria-label={ariaLabel}
      title={title}
    >
      {children}
    </button>
  );
};

Button.propTypes = {
  type: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  ariaLabel: PropTypes.string,
  title: PropTypes.string,
};

export default Button;
